import { getIsBlendoUser } from '@auth/common/util';

enum AccountType {
  blendo = 'Blendo',
  invited = 'Invited',
  openSource = 'OpenSource',
}

interface AccountTypeObj {
  invited: boolean;
  firstTimeLogin: boolean;
  isBlendoUser: boolean;
}

// ts-prune-ignore-next
export const getAccountType = ({ invited, firstTimeLogin, isBlendoUser }: AccountTypeObj) => {
  if (invited) {
    return AccountType.invited;
  }
  if (!firstTimeLogin) {
    return null;
  }
  if (isBlendoUser) {
    return AccountType.blendo;
  }
  return null;
};

export interface User {
  invited: boolean | undefined;
  firstTimeLogin: boolean;
  workspaceId: string | undefined;
  userId: string;
  name: string | undefined;
  email: string;
  workSource: string[] | undefined;
  migratedFrom: string | undefined;
  otherWorkSource: string | undefined;
  churnSource: string | undefined;
  organization: string;
}

export const getUserTraits = ({
  invited = false,
  firstTimeLogin,
  workspaceId,
  userId,
  name,
  email,
  workSource,
  churnSource,
  migratedFrom,
  otherWorkSource,
  organization,
}: User) => {
  const isBlendoUser = getIsBlendoUser();
  const accountType = getAccountType({
    invited,
    firstTimeLogin,
    isBlendoUser,
  });
  const traits = {
    userId,
    email,
    name,
    workspaceId,
    first_login: firstTimeLogin,
    ...(migratedFrom && { migration: migratedFrom }),
    ...(churnSource && { heardFrom: churnSource }),
    ...(workSource && { workSource }),
    ...(otherWorkSource && { otherWorkSource }),
    ...(accountType && { accountType }),
    ...(organization && {
      company: organization,
      organization,
    }),
  };
  return traits;
};

export const mapToWorkspaceProperties = (
  response: { workspaceId: string; onboardingStatus: number }[],
) => {
  let result = { onboarding: {} };
  if (!response) {
    return result;
  }
  response.forEach((x) => {
    result = {
      onboarding: {
        ...result.onboarding,
        [x.workspaceId]: x.onboardingStatus,
      },
    };
  });
  return result;
};
